import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { RoomModel, RoomType } from 'projects/core/src/lib/models/room.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { SelectItem } from 'primeng/api';
import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';

@Component({
  selector: 'app-room-new',
  templateUrl: './room-new.component.html',
  styleUrls: ['./room-new.component.scss']
})
export class RoomNewComponent extends BaseForm implements OnInit {

  public form = this.fb.group({
    active: new UntypedFormControl(false),
    name: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    location: new UntypedFormControl('', [Validators.required]),
    capacity: new UntypedFormControl(''),
    zip: new UntypedFormControl(''),
    street: new UntypedFormControl(''),
    addition: new UntypedFormControl(''),
    mail_registration: new UntypedFormControl('', [Validators.required, CustomValidators.email()]),
    mail_catering: new UntypedFormControl('', [CustomValidators.email()]),
  });

  public locations: Array<LocationModel> = [];
  public types: Array<SelectItem> = [];

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    if (this.auth.checkRightOrRedirect('admin.room.create')) {
      this.loading = true;
      this.types = FormHelper.getSelectList(RoomType, null, this.transloco, 'rooms.types');
      this.api.getModels('locations').subscribe({
        next: (result: any) => {
          this.locations = [];
          result.data.forEach((location: any) => {
            this.locations.push(new LocationModel().deserialize(location));
          });
        }
      }).add(() => {
        this.loading = false;
      });
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/rooms']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    const payload: any = this.form.value;
    payload.location = payload.location?.id || null;
    if (this.form.valid === true && payload.location) {
      this.submitting = true;
      this.api.saveModel('rooms', null, payload).subscribe({
        next: (result: any) => {
          const room = new RoomModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: room.name }), this.transloco.translate('common.saved'));
          this.router.navigate(['/rooms', room.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
